import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { bulkImportProducts } from "../AdminPagesCrud";
import InputLabel from "@material-ui/core/InputLabel";

const TEMPLATE_CSV = "Vendor Name,Vendor No. (Mass 90),ITEM No.,Description,Departamento,FOB c/u,PV REG,PK,Is Active\n,SAMPLE-VENDOR,SKU001,Sample Product Description,0101,8.50,10.99,1,1";

export function ImportProductsModal({ show, onClose, onSuccess, accessToken }) {
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0] || null);
        setResult(null);
        setError(null);
    };

    const handleDownloadTemplate = (e) => {
        e.preventDefault();
        const blob = new Blob([TEMPLATE_CSV], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "products-import-template.csv";
        a.click();
        URL.revokeObjectURL(url);
    };

    const handleSubmit = async () => {
        if (!file) {
            setError("Please select a file");
            return;
        }

        setIsLoading(true);
        setError(null);
        setResult(null);

        try {
            const formData = new FormData();
            formData.append("file", file);

            const response = await bulkImportProducts(formData, accessToken);
            setResult(response.data);
        } catch (err) {
            setError(err.response?.data?.error || err.message || "Import failed");
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        if (result) {
            onSuccess && onSuccess();
        }
        setFile(null);
        setResult(null);
        setError(null);
        onClose();
    };

    const handleImportAgain = () => {
        setFile(null);
        setResult(null);
        setError(null);
    };

    return (
        <Modal show={show} onHide={handleClose} aria-labelledby="import-products-modal" size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title id="import-products-modal">Import Products</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!result ? (
                    <>
                        <div className="form-group mb-4">
                            <a href="#" onClick={handleDownloadTemplate} className="text-primary">
                                Download Template (CSV)
                            </a>
                            <p className="text-muted small mt-1">Expected columns: Vendor No. (Mass 90), ITEM No., Description, Departamento, FOB c/u, PV REG, PK, Is Active (1 or 0)</p>
                        </div>
                        <div className="form-group">
                            <InputLabel>File (CSV or Excel)</InputLabel>
                            <input
                                type="file"
                                className="form-control"
                                accept=".csv,.xlsx,.xls"
                                onChange={handleFileChange}
                                disabled={isLoading}
                            />
                        </div>
                        {error && (
                            <div className="alert alert-danger mt-3" role="alert">
                                {error}
                            </div>
                        )}
                    </>
                ) : (
                    <div>
                        <div className="alert alert-info">
                            <strong>Import complete:</strong> {result.created} created, {result.updated} updated, {result.failed} failed.
                        </div>
                        {result.errors && result.errors.length > 0 && (
                            <div className="mt-3">
                                <strong>Errors:</strong>
                                <ul className="list-unstyled mt-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
                                    {result.errors.map((err, i) => (
                                        <li key={i} className="text-danger small mb-1">
                                            Row {err.row} (SKU: {err.sku}): {err.message}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                {!result ? (
                    <>
                        <button type="button" className="btn btn-light" onClick={handleClose} disabled={isLoading}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={isLoading || !file}
                        >
                            {isLoading ? "Importing..." : "Import"}
                        </button>
                    </>
                ) : (
                    <>
                        <button type="button" className="btn btn-light" onClick={handleImportAgain}>
                            Import Again
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleClose}>
                            Close
                        </button>
                    </>
                )}
            </Modal.Footer>
        </Modal>
    );
}
